import React, { useState } from 'react';
import MainCalculatorsList from '../MainCalculators';
import SharedHelmet from '../Helmet';
import RelatedLinks from '../RelatedLinks';
import { CalculatorsType } from '../ConstantsEN';
import { FirstAds, SecondAds , MobileUnderCalAds } from "../../Ads";
const TITLE = 'Price-to-Earnings Ratio Calculator - Calculate P/E Ratio for Companies';
const DESCRIPTION = 'The Price-to-Earnings Ratio (P/E Ratio) calculator calculates a company\'s P/E ratio based on the market value of a share and the earnings per share.';
const KEYWORDS = 'P/E ratio, calculate P/E ratio, P/E ratio calculator';
const OG_URL = 'https://do-calculate.com/calculator/en/pe-ratio';
function Calculator() {
    const [stockPrice, setStockPrice] = useState('');
    const [earningsPerShare, setEarningsPerShare] = useState('');
    const [peRatio, setPeRatio] = useState('');
    const [error, setError] = useState('');
    const handleCalculate = () => {
        if (!stockPrice || !earningsPerShare) {
            setError('Please enter the stock price and earnings per share correctly');
            setPeRatio('');
            return;
        }
        const stockPriceValue = parseFloat(stockPrice);
        const earningsPerShareValue = parseFloat(earningsPerShare);
        if (isNaN(stockPriceValue) || isNaN(earningsPerShareValue) || earningsPerShareValue <= 0) {
            setError('Please enter valid and positive values for the stock price and earnings per share');
            setPeRatio('');
            return;
        }
        const peRatioValue = stockPriceValue / earningsPerShareValue;
        setPeRatio(peRatioValue.toFixed(2));
        setError('');
    };
    return (
        <div>
            <SharedHelmet TITLE={TITLE} DESCRIPTION={DESCRIPTION} KEYWORDS={KEYWORDS} OG_URL={OG_URL}  />
            <div className="row">
                <div className="col-12 col-md-8">
                    <FirstAds />
                </div>
            </div>
            <div className="row">
                <div className="col-12 col-md-8">
                    <br />
                    <div className="bg-success text-white text-center" style={{ height: '40px' }}>
                        <h1 style={{ fontSize: '17px' }}>{TITLE}</h1>
                    </div>
                            <div className="border border-light">
                                <div className="row">
                                    <div>
                                        <h2 style={{fontSize:'18px'}}>How to Calculate P/E Ratio</h2>
                                        <p>
                                            The formula for calculating the P/E ratio is as follows:
                                        </p>
                                        <p>
                                            P/E Ratio = Market Value per Share ÷ Earnings per Share
                                        </p>
                                        <p>
                                            The P/E ratio is used to calculate the earnings of different company stocks and indicates a company's performance over 12 months.
                                        </p>
                                        <hr />
                                    </div>
                                </div>
                                <MobileUnderCalAds />
                                <div className="row">
                                    <div className="col-sm-12 col-md-7 calculatorStyle">
                                        <div className='p-3 mb-2 bg-success text-white'>
                                            <h2 style={{ fontSize: '16px' }}>{TITLE} </h2>
                                        </div>
                                        <hr />
                                        <div>
                                            <div>
                                                <div className="form-group d-flex align-items-center">
                                                    <b>
                                                        <label className="form-label ms-2">Stock Price</label>
                                                    </b>
                                                    <input
                                                        type="number"
                                                        placeholder="139.55"
                                                        value={stockPrice}
                                                        onChange={(e) => setStockPrice(e.target.value)}
                                                        className="form-control"
                                                        style={{ width: '150px' }}
                                                    />
                                                </div>
                                                <br />
                                                <div className="form-group d-flex align-items-center">
                                                    <b>
                                                        <label className="form-label ms-2">Earnings Per Share</label>
                                                    </b>
                                                    <input
                                                        type="number"
                                                        placeholder="4.75"
                                                        value={earningsPerShare}
                                                        onChange={(e) => setEarningsPerShare(e.target.value)}
                                                        className="form-control"
                                                        style={{ width: '150px' }}
                                                    />
                                                </div>
                                                <br />
                                                <button
                                                    className="btn btn-success"
                                                    style={{ fontSize: '20px' }}
                                                    onClick={handleCalculate}
                                                >
                                                    Calculate P/E Ratio
                                                </button>
                                            </div>
                                            <br />
                                            <div>
                                                {error !== '' ? (
                                                    <p className='p-3 mb-2 bg-warning text-white'>Error: {error}</p>
                                                ) : (
                                                    <>
                                                        {peRatio !== '' && (
                                                            <>
                                                                <p className='p-3 mb-2 bg-success text-white'>
                                                                    P/E Ratio: {peRatio}
                                                                </p>
                                                                <p className='p-3 mb-2 bg-info text-black'>
                                                                    Solution Steps: <br />
                                                                    - Divide the stock price by the earnings per share to get the P/E ratio.
                                                                </p>
                                                            </>
                                                        )}
                                                    </>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <hr />
                                <div className="row">
                                    <RelatedLinks />
                                    <hr />
                                </div>
                            </div>
                </div>
                <div className="col" >
                    <SecondAds />
                    <br />
                    <MainCalculatorsList CalculatorsTypeId={CalculatorsType.financialCalculators}></MainCalculatorsList>
                    <br />
                </div>
            </div>
             <br />
        </div>
    );
}
export default Calculator;
